import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios';

// import store from '../../store.js'

// Vue.use(VueAxios, axios);

// Configuração de URLs usando variáveis de ambiente
const API_BASE_URL = process.env.VUE_APP_API_BASE_URL || 'http://localhost:3000'
// const API_VERSION = process.env.VUE_APP_API_VERSION || '/api/v1'
const API_URL_COMPLETE = `${API_BASE_URL}/`


// const securedAxiosInstance = axios.create({
//   baseURL: API_URL_COMPLETE,
//   withCredentials: true,
//   headers: {
//     'Content-Type': 'application/json'
//   }
// })

const plainAxiosInstance = axios.create({
  baseURL: API_URL_COMPLETE,
  // withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
  }
})

plainAxiosInstance.interceptors.request.use(
  (config) => {
      if (!config.url.includes('auth/')){
        let url = `api/v1${config.url}`
        config.url = url
    }

    return config;
  },
  (error) => {
    alert("Ops! Algo errado com a requisição.");
    console.log(error);
    return Promise.reject(error);
  }
);


// Vue.use(VueAxios, {axios: plainAxiosInstance});
Vue.use(VueAxios, plainAxiosInstance);


export default plainAxiosInstance;


